import React from 'react';

import Button from '../../../Common/Button';
import Icon from '../../../Common/Icon';
import RadioWrapper from '../../../FormFields/WrapperRadio';
import InputSelect from '../../../FormFields/Select';
import InputEmail from '../../../FormFields/Email';
import Condition from '../../../../Models/FieldCondition';
import RuleCondition from '../../../../Models/FieldConditionRule';
import Trigger from '../../../../Models/Trigger';
import withFieldActions from '../withFieldActions';

import FormContextProvider, { FormContext } from '../../../../Context/FormContext';

import ConditionalFields from '../../../../Services/ConditionalFields';
import Utils from '../../../../Services/Utils';
import ConfigService from '../../../../Services/api/Config';
import { ReactComponent as DeleteIcon } from '../../../../../img/icon-delete.svg';
import { ReactComponent as OpenIcon } from '../../../../../img/expand-closed.svg';
import { ReactComponent as EditIcon } from '../../../../../img/icon-template-edit.svg';
import Checkbox from '../../../FormFields/Checkbox';
import TagSelect from '../../../Common/NewSelect';
import { TAGS_AVAILABLE, IS_ADMIN } from '../../../../Context/DynamicFormContext';

const triggerTypesOptions = [
  { value: '0', label: 'Extend the current \n workflow' },
  { value: '1', label: 'Send email' }
];
const errorRequired = 'This field is required';

function withConditionsAndTriggers(WrappedComponent, selectData) {
  return class extends withFieldActions(WrappedComponent, selectData) {
    removeCondition = (index) => {
      const { internalField } = this.state;
      internalField.conditions.splice(index, 1);
      this.setState({ internalField: { ...internalField } });
    };

    removeRule = (index) => {
      const { internalField } = this.state;
      internalField.conditionsRules.splice(index, 1);
      this.setState({ internalField: { ...internalField } });
    };

    removeTrigger = (index) => {
      const { internalField } = this.state;
      internalField.triggers.splice(index, 1);
      this.setState({ internalField: { ...internalField } });
    };

    addOrEditCondition = (condition, editingIndex) => {
      this.setState({
        currentConditionView: 1,
        currentCondition: condition,
        oldCondition: { ...condition }
      });
      if (editingIndex !== undefined) {
        this.editingIndex = editingIndex;
      } else {
        this.editingIndex = -1;
      }
    };

    addOrEditRule = (rule, editingIndex) => {
      this.setState({
        currentConditionView: 2,
        currentRule: rule
      });
      if (editingIndex !== undefined) {
        this.editingIndex = editingIndex;
      } else {
        this.editingIndex = -1;
      }
    };

    addOrEditTrigger = (trigger, editingIndex) => {
      this.setState({
        currentTriggerView: 1,
        currentTrigger: trigger
      });
      if (editingIndex !== undefined) {
        this.editingIndex = editingIndex;
      } else {
        this.editingIndex = -1;
      }
    };

    submitCondition = () => {
      const { internalField, currentCondition } = this.state;
      const index = this.editingIndex;
      if (index !== -1) {
        internalField.conditions[index] = new Condition(currentCondition);
      } else {
        internalField.conditions = [...internalField.conditions, new Condition(currentCondition)];
      }
      this.setState({
        internalField: { ...internalField, conditions: [...internalField.conditions] },
        currentConditionView: 0,
        currentCondition: null,
        oldCondition: null
      });
      this.editingIndex = -1;
    };

    submitRule = () => {
      const { internalField, currentRule } = this.state;
      const index = this.editingIndex;
      if (index !== -1) {
        internalField.conditionsRules[index] = new RuleCondition(currentRule);
      } else {
        internalField.conditionsRules = [...internalField.conditionsRules, new RuleCondition(currentRule)];
      }
      this.setState({
        internalField: { ...internalField, conditionsRules: [...internalField.conditionsRules] },
        currentConditionView: 0,
        currentRule: null
      });
      this.editingIndex = -1;
    };

    submitTrigger = () => {
      const { internalField, currentTrigger } = this.state;
      const index = this.editingIndex;
      if (index !== -1) {
        internalField.triggers[index] = new Trigger(currentTrigger);
      } else {
        internalField.triggers = [...internalField.triggers, new Trigger(currentTrigger)];
      }
      this.setState({
        internalField: { ...internalField, triggers: [...internalField.triggers] },
        currentTriggerView: 0,
        currentTrigger: null
      });
      this.editingIndex = -1;
    };

    _getValueLabel = (value) => {
      if (Utils.isNull(value)) {
        return value;
      }
      let result = null;
      if (Array.isArray(value)) {
        const arrayValues = [];
        value.forEach((item) => {
          // eslint-disable-next-line no-nested-ternary
          if (item.label) {
            arrayValues.push(item.label);
          }
          else {
            arrayValues.push(item.value ? item.value : item);
          }
        });
        result = arrayValues.join(',');
      } else {
        // eslint-disable-next-line no-nested-ternary
        if (value.label) {
          result = value.label;
        }
        else {
          result = (value.value ? value.value : value);
        }
      }
      return result;
    };

    _isFieldComponent = (field, value) => {
      switch (field.component) {
        case 'fileImageInput':
        case 'fileInput':
        case 'imageInput':
        case 'imageMultipleInput':
        case 'signatureInput':
        case 'freeText':
        case 'fileEmbedded':
          return true;
        default:
          const validComponents = ['textArea', 'checkbox', 'checkboxJustifiedLeft', 'textInput', 'phoneInput'];
          return validComponents.includes(field.component) && (value === 'Is Empty' || value === 'Is Not Empty');
      }
    };

    cancelCondition = () => {
      const { internalField, oldCondition } = this.state;
      const index = this.editingIndex;
      if(internalField.conditions && internalField.conditions.length > 0){
        if (index !== -1) internalField.conditions[index] = new Condition(oldCondition);
        else internalField.conditions = [...internalField.conditions];
      }
      this.setState({
        internalField: { ...internalField, conditions: [...internalField.conditions] },
        currentConditionView: 0,
        currentCondition: null,
        currentRule: null,
        oldCondition: null
      });
      this.editingIndex = -1;
    };

    cancelTrigger = () => {
      this.setState({
        currentTriggerView: 0,
        currentTrigger: null
      });
      this.editingIndex = -1;
    };

    changeConditionData = (field, value) => {
      const { currentCondition } = this.state;
      if (field === 'conditionField') {
        currentCondition['conditionType'] = null;
        currentCondition.errors['conditionType'] = errorRequired;
        currentCondition['conditionValue'] = null;
        currentCondition.errors['conditionValue'] = errorRequired;
      }
      if (field === 'conditionType' && (value.value === 'Empty' || value.value === 'Not Empty' || value.value === 'Is Empty' || value.value === 'Is Not Empty')) {
        delete currentCondition.errors['conditionValue'];
      }
      if(!Array.isArray(value) && Utils.isObject(value) && Utils.isObjectEmpty(value)){
        currentCondition[field] = null;
      }
      else{
        currentCondition[field] = value;
      }
      this.setState({
        currentCondition: { ...currentCondition }
      });
    };

    changeConditionError = (field, value) => {
      const { currentCondition } = this.state;
      currentCondition.errors[field] = value;
      this.setState({
        currentCondition: { ...currentCondition }
      });
    };

    changeRuleData = (field, value) => {
      const { currentRule } = this.state;
      if (field === 'conditionField') {
        currentRule['ruleValue'] = null;
        currentRule.errors['ruleValue'] = errorRequired;
        currentRule['conditionValue'] = null;
        currentRule.errors['conditionValue'] = errorRequired;
      }
      currentRule[field] = value;
      this.setState({
        currentRule: { ...currentRule }
      });
    };

    changeRuleError = (field, value) => {
      const { currentRule } = this.state;
      currentRule.errors[field] = value;
      this.setState({
        currentRule: { ...currentRule }
      });
    };

    addMultipleElement = (keyValue, values) => {
      const { currentTrigger } = this.state;
      values.push('');
      currentTrigger[keyValue] = values;
      this.setState({
        currentTrigger: { ...currentTrigger }
      });
      this.changeTriggerErrorType();
    };

    removeMultipleElement = (keyValue, index) => {
      const { currentTrigger } = this.state;
      const oldValues = currentTrigger[keyValue] || [''];
      const values = [...oldValues];
      if (values.length === 1) {
        values[0] = '';
      } else {
        values.forEach((value, key) => {
          if (key > index) {
            values[key - 1] = value;
          }
        });
        values.splice(values.length - 1, 1);
      }
      currentTrigger[keyValue] = values;
      this.setState({
        currentTrigger: { ...currentTrigger }
      });
      this.changeTriggerError(keyValue + index, '');
      this.changeTriggerErrorType();
    };

    changeTriggerData = (field, value, index) => {
      const { currentTrigger } = this.state;
      const { chargeCodes } = this.props;
      if (Utils.isNull(index)) {
        currentTrigger[field] = value;
      } else {
        currentTrigger[field][index] = value;
      }
      if (['emails', 'contactTypes', 'triggerType'].includes(field)) {
        this.changeTriggerErrorType();
      }
      if (field === 'chargeCode') {
        currentTrigger.charge_code_id = currentTrigger.chargeCode.value;
      }
      if (field === 'pmsPlatform') {
        const pmsPlatformValue = !Utils.isNull(value) ? value?.value || value : null;
        const chargesOptions = !Utils.isNull(pmsPlatformValue) ?
        chargeCodes.filter(item => item.pms_platform?.id === pmsPlatformValue) : chargeCodes;
        if (!chargesOptions.find(item => item.id === currentTrigger.charge_code_id)) {
          currentTrigger.charge_code_id = null;
        }
      }
      this.setState({
        currentTrigger: { ...currentTrigger }
      });
    };

    changeTriggerError = (field, value) => {
      const { currentTrigger } = this.state;
      currentTrigger.errors[field] = value;
      this.setState({
        currentTrigger: { ...currentTrigger }
      });
    };

    changeTriggerErrorType = () => {
      const { currentTrigger } = this.state;
      let error = true;
      if (currentTrigger['triggerType'] !== '0') {
        currentTrigger.errors['templateID'] = '';
      }
      if (currentTrigger['triggerType'] !== '1') {
        currentTrigger.errors = {
          emails : '',
          emails0 : ''
        }
        if (!Utils.isEmpty(currentTrigger['emails'])) {
          currentTrigger['emails'].map((item, index) => {
            currentTrigger.errors['emails' + index] = '';
          });
        }
      } else {
        if (!Utils.isEmpty(currentTrigger['emails'])) {
          currentTrigger['emails'].map((item, index) => {
            if (!Utils.isNull(item)) {
              error = !Utils.isNull(currentTrigger.errors['emails' + index]);
            }
          });
        }
        if (error) {
          error = Utils.isEmpty(currentTrigger['emails']);
        }
      }
      this.setState({
        currentTrigger: { ...currentTrigger }
      });
    };

    renderConditionsTab = () => {
      const { currentConditionView } = this.state;
      switch (currentConditionView) {
        case 0:
          return this.renderAddCondition();
        case 1:
          return this.renderDisplayCondition();
        case 2:
          return this.renderRuleCondition();
      }
    };

    renderTriggersTab = () => {
      const { currentTriggerView } = this.state;
      switch (currentTriggerView) {
        case 0:
          return this.renderAddTrigger();
        case 1:
          return this.renderTriggerDetail();
      }
    };

    renderAddTrigger = () => {
      const { internalField } = this.state;
      return (
        <div className="Widget_Form_Triggers">
          <div className="Trigger_List">
            Triggers:
            {internalField.triggers && internalField.triggers.length > 0 && (
              <ul className="Trigger_List_Inner">{internalField.triggers.map((item, index) => this.renderTriggerItem(item, index))}</ul>
            )}
            <div className="Widget_Form_Triggers_Add" onClick={() => this.addOrEditTrigger(new Trigger())}>
              Add trigger
              <Icon width="15" height="15" color="secondaryColor">
                <OpenIcon alt="expand-closed" />
              </Icon>
            </div>
          </div>
        </div>
      );
    };

    // eslint-disable-next-line sonarjs/cognitive-complexity
    renderTriggerDetail = () => {
      const { triggerTemplates, contactTypes, chargeCodes, pmsPlatforms, api } = this.props;
      const { currentTrigger, internalField } = this.state;
      const pmsPlatformValue = !Utils.isNull(currentTrigger.pmsPlatform) ? currentTrigger.pmsPlatform?.value || currentTrigger.pmsPlatform : null;
      const chargesOptions = !Utils.isNull(pmsPlatformValue) ?
        chargeCodes.filter(item => item.pms_platform?.id === pmsPlatformValue) : chargeCodes;
      const triggerTemplateOptions = Array.isArray(triggerTemplates)
        ? triggerTemplates.map((item) => {
            return { value: item.id, label: item.name };
          })
        : [];
      const contactTypeOptions = Array.isArray(contactTypes)
        ? contactTypes.map((item) => {
          return { value: item.id, label: item.name };
        })
        : [];
      const pmsPlatformOptions = Array.isArray(pmsPlatforms)
        ? pmsPlatforms.map((item) => {
          return { value: item.id, label: item.name };
        })
        : [];
      const chargeCodeOptions = Array.isArray(chargesOptions)
        ? (chargesOptions.map((item) => {
          return { value: item.id, label: `${item.code} - ${item.description}` };
        }))
        : [];
      const templateID =
        currentTrigger.templateID && currentTrigger.templateID.value
          ? triggerTemplateOptions.find((item) => item.value === currentTrigger.templateID.value)
          : null;
      const options = ConditionalFields.getOptions(internalField);
      const emails = !Utils.isEmpty(currentTrigger.emails) ? currentTrigger.emails : [''];
      const triggerOptions = [...triggerTypesOptions];
      if (api.permissionAvailableAccount('permission_view_work_order')) {
        triggerOptions.push({ value: '2', label: 'Create work order' });
      }
      if (api.permissionAvailableAccount('permission_view_charges') && api.permissionAvailable('permission_define_property_charge_codes')) {
        triggerOptions.push({ value: '3', label: 'Create charge' });
      }
      return (
        <FormContextProvider>
          <FormContext.Consumer>
            {(context) => (
              <div className="Condition_Form">
                <InputSelect
                  label="When this field..."
                  placeholder="No condition"
                  required
                  value={currentTrigger.conditionType}
                  options={options}
                  error={currentTrigger.errors['conditionType']}
                  onError={(error) => this.changeTriggerError('conditionType', error)}
                  onChange={(v) => this.changeTriggerData('conditionType', v)}
                />
                {currentTrigger.conditionType &&
                  ConditionalFields.getValueInput(
                    internalField,
                    (v) => this.changeTriggerData('conditionValue', v),
                    (error) => this.changeTriggerError('conditionValue', error),
                    currentTrigger,
                    true
                  )}
                {(currentTrigger.conditionValue || (currentTrigger.conditionType && this._isFieldComponent(internalField, currentTrigger.conditionType['value']))) && (
                  <RadioWrapper
                    label="Action..."
                    required
                    options={triggerOptions}
                    name="triggerType"
                    value={currentTrigger.triggerType}
                    onChange={this.changeTriggerData}
                    error={currentTrigger.errors['triggerType']}
                    className="InputRadio_Block"
                    onError={(error) => this.changeTriggerError('triggerType', error)}
                  />
                )}
                {currentTrigger.triggerType === '0' &&
                  (currentTrigger.conditionValue || (currentTrigger.conditionType && this._isFieldComponent(internalField, currentTrigger.conditionType['value']))) &&
                  !Utils.isNull(currentTrigger.triggerType) && (
                  <InputSelect
                    label="With..."
                    required
                    value={templateID}
                    options={triggerTemplateOptions}
                    error={currentTrigger.errors['templateID']}
                    onError={(error) => this.changeTriggerError('templateID', error)}
                    onChange={(v) => this.changeTriggerData('templateID', v)}
                  />
                )}
                {currentTrigger.triggerType === '2' &&
                  (currentTrigger.conditionValue || (currentTrigger.conditionType && this._isFieldComponent(internalField, currentTrigger.conditionType['value']))) &&
                  !Utils.isNull(currentTrigger.triggerType) && (
                  <Checkbox
                    label="Work Order Required"
                    checked={currentTrigger.workOrderRequired}
                    error={currentTrigger.errors['workOrderRequired']}
                    onError={(error) => this.changeTriggerError('workOrderRequired', error)}
                    onChange={(v) => this.changeTriggerData('workOrderRequired', v)}
                  />
                )}
                {currentTrigger.triggerType === '1' &&
                  (currentTrigger.conditionValue || (currentTrigger.conditionType && this._isFieldComponent(internalField, currentTrigger.conditionType['value']))) &&
                  !Utils.isNull(currentTrigger.triggerType) && (
                  <div className="InputWrapper WrapperEmails">
                    <Checkbox 
                      label="Trigger upon submission" 
                      checked={currentTrigger.trigger_upon_submission} 
                      onChange={(v) => this.changeTriggerData('trigger_upon_submission', v)}
                      error={currentTrigger.errors['trigger_upon_submission']}
                      onError={(error) => this.changeTriggerError('trigger_upon_submission', error)} 
                      className="wrapper-stars"
                      />
                    {emails.map((email, index) => (
                      <div className="InputWrapper_Email" key={index}>
                        <InputEmail
                          label={`Email ${index + 1}`}
                          required={currentTrigger.contactTypes ? false : true}
                          value={email}
                          error={currentTrigger.errors['emails' + index]}
                          onError={(error) => this.changeTriggerError('emails' + index, error)}
                          onChange={(v) => this.changeTriggerData('emails', v, index)}
                        />
                        <Icon width="17" height="18" color="secondaryColor" onClick={() => this.removeMultipleElement('emails', index)}>
                          <DeleteIcon alt="icon-delete" />
                        </Icon>
                      </div>
                    ))}
                    <Button className="Button_Small" onClick={() => this.addMultipleElement('emails', emails)}>
                      Add Email
                      <Icon width="10" height="10" color="white">
                        <OpenIcon alt="expand-closed" />
                      </Icon>
                    </Button>
                    <div className="InputWrapper_Email">
                      <InputSelect
                        label="ContactTypes"
                        value={currentTrigger.contactTypes}
                        options={contactTypeOptions}
                        multiple={true}
                        error={currentTrigger.errors['contactTypes']}
                        onError={(error) => this.changeTriggerError('contactTypes', error)}
                        onChange={(v) => this.changeTriggerData('contactTypes', v)}
                      />
                    </div>
                  </div>
                )}
                {currentTrigger.triggerType === '3' &&
                  (currentTrigger.conditionValue || (currentTrigger.conditionType && this._isFieldComponent(internalField, currentTrigger.conditionType['value']))) &&
                  !Utils.isNull(currentTrigger.triggerType) && (
                  <div className="InputWrapper">
                    <div className="InputWrapper_Charge">
                      <InputSelect
                        label="PMS Platform"
                        required
                        value={currentTrigger.pmsPlatform}
                        options={pmsPlatformOptions}
                        multiple={false}
                        error={currentTrigger.errors['pmsPlatform']}
                        onError={(error) => this.changeTriggerError('pmsPlatform', error)}
                        onChange={(v) => this.changeTriggerData('pmsPlatform', v)}
                      />
                      { !Utils.isNull(currentTrigger.pmsPlatform) && (
                        <InputSelect
                          label="Charge Code"
                          required
                          value={currentTrigger.charge_code_id}
                          options={chargeCodeOptions}
                          multiple={false}
                          error={currentTrigger.errors['chargeCode']}
                          onError={(error) => this.changeTriggerError('chargeCode', error)}
                          onChange={(v) => this.changeTriggerData('chargeCode', v)}
                        />
                      )}
                    </div>
                  </div>
                )}
                <div className="Condition_Form_Footer">
                  <Button className="Button_Small" onClick={() => context.submit(this.submitTrigger, currentTrigger.errors)}>
                    Save
                  </Button>
                  <Button className="Button_Small Button_Cancel" onClick={() => context.cancel(this.cancelTrigger)}>
                    Cancel
                  </Button>
                </div>
              </div>
            )}
          </FormContext.Consumer>
        </FormContextProvider>
      );
    };

    renderDisplayCondition = () => {
      const { api } = this.props;
      const { currentCondition, internalField } = this.state;
      const conditionFields = api.getValidFieldsForConditions(internalField.id, false);
      return (
        <FormContextProvider>
          <FormContext.Consumer>
            {(context) => (
              <div className="Condition_Form">
                <InputSelect
                  label="Show this field when..."
                  required
                  value={currentCondition.conditionField}
                  options={conditionFields.map((option) => {
                    return { label: option.label, value: option.id };
                  })}
                  error={currentCondition.errors['conditionField']}
                  onError={(error) => this.changeConditionError('conditionField', error)}
                  onChange={(v) => this.changeConditionData('conditionField', v)}
                />
                {currentCondition.conditionField && (
                  <InputSelect
                    label="Condition..."
                    placeholder="No condition"
                    required
                    value={currentCondition.conditionType}
                    options={ConditionalFields.getOptions(conditionFields.find((item) => item.id === currentCondition.conditionField.value))}
                    error={currentCondition.errors['conditionType']}
                    onError={(error) => this.changeConditionError('conditionType', error)}
                    onChange={(v) => this.changeConditionData('conditionType', v)}
                  />
                )}
                {currentCondition.conditionType &&
                  ConditionalFields.getValueInput(
                    conditionFields.find((item) => item.id === currentCondition.conditionField.value),
                    (v) => this.changeConditionData('conditionValue', v),
                    (error) => this.changeConditionError('conditionValue', error),
                    currentCondition
                  )}
                <div className="Condition_Form_Footer">
                  <Button className="Button Button_Small" onClick={() => context.submit(this.submitCondition, currentCondition.errors)}>
                    Save
                  </Button>
                  <Button className="Button Button_Small Button_Cancel" onClick={() => context.cancel(this.cancelCondition)}>
                    Cancel
                  </Button>
                </div>
              </div>
            )}
          </FormContext.Consumer>
        </FormContextProvider>
      );
    };

    renderRuleCondition = () => {
      const { api } = this.props;
      const { currentRule, internalField } = this.state;
      const conditionFields = api.getValidFieldsForConditions(internalField.id, true);
      return (
        <FormContextProvider>
          <FormContext.Consumer>
            {(context) => (
              <div className="Condition_Form">
                <InputSelect
                  label="When..."
                  required
                  value={currentRule.conditionField}
                  options={conditionFields.map((option) => {
                    return { label: option.label, value: option.id };
                  })}
                  error={currentRule.errors['conditionField']}
                  onError={(error) => this.changeRuleError('conditionField', error)}
                  onChange={(v) => this.changeRuleData('conditionField', v)}
                />
                {currentRule.conditionField &&
                  ConditionalFields.getValueInput(
                    conditionFields.find((item) => item.id === currentRule.conditionField.value),
                    (v) => this.changeRuleData('conditionValue', v),
                    (error) => this.changeRuleError('conditionValue', error),
                    currentRule,
                    false,
                    'Equals...'
                  )}
                {currentRule.conditionValue &&
                  ConditionalFields.getValueInput(
                    internalField,
                    (v) => this.changeRuleData('ruleValue', v),
                    (error) => this.changeRuleError('ruleValue', error),
                    currentRule,
                    true,
                    'Auto set to...',
                    'ruleValue'
                  )}
                <div className="Condition_Form_Footer">
                  <Button className="Button_Small" onClick={() => context.submit(this.submitRule, currentRule.errors)}>
                    Save
                  </Button>
                  <Button className="Button_Small Button_Cancel" onClick={() => context.cancel(this.cancelCondition)}>
                    Cancel
                  </Button>
                </div>
              </div>
            )}
          </FormContext.Consumer>
        </FormContextProvider>
      );
    };

    renderConditionItem = (item, index) => {
      const value = this._getValueLabel(item.conditionValue);
      const styleTitle = {
        color: ConfigService.getColor('primaryColor')
      };
      return (
        <li className="Condition_Item" key={index} style={styleTitle}>
          <div className="Condition_Item_Text">
            {item.conditionField.label} {item.conditionType.label} <span className="Bold">{value}</span>
          </div>
          <div className="Condition_Item_Actions">
            <div className="Condition_Item_Actions_Edit" onClick={() => this.addOrEditCondition(item, index)}>
              <Icon width="16" height="16" color="secondaryColor">
                <EditIcon alt="icon-template-edit" />
              </Icon>
            </div>
            <div className="Condition_Item_Actions_Remove" onClick={() => this.removeCondition(index)}>
              <Icon width="17" height="18" color="secondaryColor">
                <DeleteIcon alt="icon-delete" />
              </Icon>
            </div>
          </div>
        </li>
      );
    };

    renderRuleItem = (item, index) => {
      const conditionValue = this._getValueLabel(item.conditionValue);
      const ruleValue = this._getValueLabel(item.ruleValue);
      const styleTitle = {
        color: ConfigService.getColor('primaryColor')
      };
      return (
        <li className="Condition_Item" key={index} style={styleTitle}>
          <div className="Condition_Item_Text">
            <span className="Bold">{ruleValue}</span> if {item.conditionField.label} is <span className="Bold">{conditionValue}</span>
          </div>
          <div className="Condition_Item_Actions">
            <div className="Condition_Item_Actions_Edit" onClick={() => this.addOrEditRule(item, index)}>
              <Icon width="16" height="16" color="secondaryColor">
                <EditIcon alt="icon-template-edit" />
              </Icon>
            </div>
            <div className="Condition_Item_Actions_Remove" onClick={() => this.removeRule(index)}>
              <Icon width="17" height="18" color="secondaryColor">
                <DeleteIcon alt="icon-delete" />
              </Icon>
            </div>
          </div>
        </li>
      );
    };

    renderTriggerItem = (item, index) => {
      const { api } = this.props;
      const value = this._getValueLabel(item.conditionValue);
      const styleTitle = {
        color: ConfigService.getColor('primaryColor')
      };
      const triggerOptions = [...triggerTypesOptions];
      if (api.permissionAvailableAccount('permission_view_work_order')) {
        triggerOptions.push({ value: '2', label: 'Create work order' });
      }
      if (api.permissionAvailableAccount('permission_view_charges') && api.permissionAvailable('permission_define_property_charge_codes')) {
        triggerOptions.push({ value: '3', label: 'Create charge' });
      }
      const triggerType = triggerOptions.filter((option) => item.triggerType === option.value)[0];
       const label = triggerType?.label;

      return (
        <li className="Trigger_Item" key={index} style={styleTitle}>
          <div className="Trigger_Item_Text">
            <span>
              {label} - {item.conditionType.label}:
            </span>
            <span className="Bold">{' ' + value}</span>
          </div>
          <div className="Trigger_Item_Actions">
            <div className="Trigger_Item_Actions_Edit" onClick={() => this.addOrEditTrigger(item, index)}>
              <Icon width="16" height="16" color="secondaryColor">
                <EditIcon alt="icon-template-edit" />
              </Icon>
            </div>
            <div className="Trigger_Item_Actions_Remove" onClick={() => this.removeTrigger(index)}>
              <Icon width="17" height="18" color="secondaryColor">
                <DeleteIcon alt="icon-delete" />
              </Icon>
            </div>
          </div>
        </li>
      );
    };

    renderAddCondition = () => {
      const { api } = this.props;
      const { internalField } = this.state;
      const conditionFields = api.getValidFieldsForConditions(internalField.id, false);
      const ruleFields = api.getValidFieldsForConditions(internalField.id, true);
      return (
        <div className="Widget_Form_Conditions">
          <div className="Conditions_List">
            Display conditions:
            {internalField.conditions && internalField.conditions.length > 0 && (
              <ul className="Conditions_List_Inner">{internalField.conditions.map((item, index) => this.renderConditionItem(item, index))}</ul>
            )}
            {(conditionFields.length > 0 && (
              <div className="Widget_Form_Conditions_Add" onClick={() => this.addOrEditCondition(new Condition())}>
                Add display condition
                <Icon width="15" height="15" color="secondaryColor">
                  <OpenIcon alt="expand-closed" />
                </Icon>
              </div>
            )) || <div>Add additional fields to dynamic form before creating a condition</div>}
          </div>
          <div className="Conditions_List">
            Value rules:
            {internalField.conditionsRules && internalField.conditionsRules.length > 0 && (
              <ul className="Conditions_List_Inner">{internalField.conditionsRules.map((item, index) => this.renderRuleItem(item, index))}</ul>
            )}
            {ruleFields.length > 0 && (
              <div className="Widget_Form_Conditions_Add" onClick={() => this.addOrEditRule(new RuleCondition())}>
                Add value rule
                <Icon width="15" height="15" color="secondaryColor">
                  <OpenIcon alt="expand-closed" />
                </Icon>
              </div>
            )}
          </div>
        </div>
      );
    };

    renderForm = (renderConfigTab) => {
      const { internalField } = this.state;
      let tagTypeOptions=[];
       if(TAGS_AVAILABLE && TAGS_AVAILABLE.length > 0){
          TAGS_AVAILABLE.forEach((item)=> {
            if(item.allow_use_in_dynamic_forms){
              tagTypeOptions.push({value: item.id, label: item.display_name || item.tag_name, tag_name: item.tag_name});
            }
            if(!item.allow_use_in_dynamic_forms) {
              if(internalField.tags_available && internalField.tags_available.length > 0) {
                    internalField.tags_available.filter((data , index)=>{
                    if(data == item.id) {
                    internalField.tags_available.splice(index, 1);
                    }
                })
              }
            }
          })
       }
      return (
        <div className="Widget_Form">
          {renderConfigTab(internalField, this.changeFieldValue, this.changeFieldErrors)}
          <hr />
          {this.renderConditionsTab()}
          <hr />
          {this.renderTriggersTab()}
          <hr/>
          <div className='Tagging_List'>
          Tag:
          <TagSelect
            isMulti={true}
            onValueChange={(selectedValues) => {
            this.changeFieldValue('tags_available', selectedValues)}}
            value={internalField.tags_available}
            controlShouldRenderValue={false}
            showValuesContainer={true}
            availableTags={tagTypeOptions}
            isAdmin={IS_ADMIN}
          />
          </div>
        </div>
      );
    };
  };
}

export default withConditionsAndTriggers;
